(() => {
  'use strict';

  // c_collection-banner.js
  // Boostの絞り込み（/collections/{handle}/{tag} のパス型URL）に合わせて
  // コレクションバナーの見出しをURLから組み直す。c_breadcrumb.js と同じURL駆動の考え方。
  //
  // 表示ルール:
  //   /collections/{handle}        → コレクション表示名
  //   /collections/{handle}/{tag}  → タグ名
  //
  // コレクション表示名の解決順（多層フォールバック）:
  //   1. data-collection-names（snippets/c_collection-names.liquid が出力）… 安定・優先
  //   2. Boostのフィルタ項目クリックで学習した実行時キャッシュ（対応表に無いコレクション用）
  //   3. どちらも無ければ、そのURLのサーバー描画をスナップショット保存/復元して凌ぐ
  //
  // 前提と制約:
  //   - タグ表示名はURLのデコード値を使う（英字タグは Half Sleeve → half-sleeve と非対応）。
  //   - 説明文は書き換えない（URLから正しい値を復元できないため）。
  //   - 多言語サブパス（/en/…）は非対応。

  // 複数セクションで読み込まれても初期化は1回だけ
  if (window.__cCollectionBannerInit) return;
  window.__cCollectionBannerInit = true;

  const SELECTOR = {
    collectionNames: '[data-collection-names]',
    boostItem: '[data-action="select-filter-item"]',
    title: '[data-collection-banner-title]',
  };

  function normalizePath(path) {
    if (!path) return '';
    let decoded = path;
    try {
      decoded = decodeURIComponent(path);
    } catch (error) {
      decoded = path;
    }
    if (decoded.length > 1 && decoded.endsWith('/')) {
      decoded = decoded.slice(0, -1);
    }
    return decoded;
  }

  // Liquidが出力した handle→表示名 の対応表（推測せず実データを使う）
  function getCollectionNames() {
    const el = document.querySelector(SELECTOR.collectionNames);
    if (!el || !el.dataset.collectionNames) return {};
    try {
      return JSON.parse(el.dataset.collectionNames);
    } catch (error) {
      return {};
    }
  }

  // Boostのフィルタ項目クリックで学習する handle→表示名（対応表フォールバック）
  const runtimeNames = {};

  function parseBoostMeta(button) {
    let raw = button.getAttribute('data-metadata') || button.getAttribute('metadata');
    if (!raw) {
      const inner = button.querySelector('[data-metadata]');
      if (inner) raw = inner.getAttribute('data-metadata');
    }
    if (!raw) return null;
    try {
      const data = JSON.parse(raw);
      return (data && data.action && data.action.optionCollection) || null;
    } catch (error) {
      return null;
    }
  }

  function learnCollectionName(event) {
    const button = event.target.closest(SELECTOR.boostItem);
    if (!button) return;
    const meta = parseBoostMeta(button);
    if (!meta || meta.filterType !== 'collection') return;
    if (meta.handle && meta.displayName) {
      runtimeNames[meta.handle] = meta.displayName;
    }
  }

  /* ========== 見出しをURLに追従 ========== */

  // 対応表に無いコレクション（例: all）用に、URLごとのサーバー描画を保存/復元する
  const snapshots = new Map();

  function urlKey() {
    return normalizePath(window.location.pathname);
  }

  function parseCollectionPath() {
    const parts = normalizePath(window.location.pathname).split('/').filter(Boolean);
    const i = parts.indexOf('collections');
    if (i === -1) return null;
    return {
      handle: parts[i + 1] || '',
      tag: parts[i + 2] || '',
    };
  }

  // コレクション名の解決: 対応表 → Boost学習キャッシュ の順
  function collectionNameFor(handle) {
    const names = getCollectionNames();
    if (names[handle]) return names[handle];
    if (runtimeNames[handle]) return runtimeNames[handle];
    return '';
  }

  function applyTitle() {
    const heading = document.querySelector(SELECTOR.title);
    if (!heading) return;

    const info = parseCollectionPath();
    if (!info || !info.handle) return;

    const key = urlKey();
    // タグ絞り込み中はタグ名、それ以外はコレクション名
    const resolved = info.tag || collectionNameFor(info.handle);
    const text = resolved || snapshots.get(key) || '';

    // 名前を組み立てられない初回訪問（例: all）はサーバー描画を正として保存するだけ
    if (!text) {
      snapshots.set(key, (heading.textContent || '').trim());
      return;
    }

    snapshots.set(key, text);
    if ((heading.textContent || '').trim() !== text) {
      heading.textContent = text;
    }
  }

  /* ========== URL変化の検知（pushState/replaceState/戻る） ========== */

  // pushState/replaceState を監視して c:locationchange を発火（複数ファイルで二重適用しない）
  function ensureHistoryPatched() {
    if (window.__cHistoryPatched) return;
    window.__cHistoryPatched = true;
    ['pushState', 'replaceState'].forEach((method) => {
      const original = history[method];
      history[method] = function patched(...args) {
        const result = original.apply(this, args);
        window.dispatchEvent(new Event('c:locationchange'));
        return result;
      };
    });
  }

  ensureHistoryPatched();
  applyTitle();

  // Boostのフィルタ項目クリックで名前を学習（描画自体はURL変化で行う）
  document.addEventListener('click', learnCollectionName);
  window.addEventListener('popstate', applyTitle);
  window.addEventListener('c:locationchange', applyTitle);
  document.addEventListener('shopify:section:load', applyTitle);
})();
